module.exports = __webpack_public_path__ + "img/middle.6af8449a.png";